import { ChangeEvent, useId } from "react";
import { TextInputProps } from "../props";
import { TextAreaContainer } from "./styles";

export interface ITextArea extends TextInputProps {
  title: string;
}

export const TextArea = ({
  onChange,
  placeholder,
  value,
  title,
}: ITextArea) => {
  const textareaId = useId();

  function handleChange(event: ChangeEvent<HTMLTextAreaElement>) {
    onChange(event.target.value);
  }

  return (
    <TextAreaContainer>
      <label htmlFor={textareaId}>{title}</label>
      <span>
        <textarea
          id={textareaId}
          value={value}
          placeholder={placeholder}
          onChange={(e) => handleChange(e)}
        />
      </span>
    </TextAreaContainer>
  );
};
